import { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  doc,
  writeBatch,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";

function PaymentRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRequests = async () => {
    try {
      const snap = await getDocs(collection(db, "paymentRequests"));

      const data = snap.docs
        .map((d) => ({
          id: d.id,
          ...d.data(),
        }))
        .sort((a, b) => {
          const at = a.createdAt?.toMillis?.() || 0;
          const bt = b.createdAt?.toMillis?.() || 0;
          return bt - at;
        });

      setRequests(data);
    } catch (err) {
      console.error(err);
      alert("❌ Payment Requests Load Failed");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRequests();
  }, []);

  const approvePayment = async (item) => {
    if (
      !window.confirm(
        `₹${item.amount} payment approve करें?\n\nUTR: ${item.utr}`
      )
    ) {
      return;
    }

    try {
      const batch = writeBatch(db);

      batch.update(doc(db, "paymentRequests", item.id), {
        status: "approved",
        reviewedAt: serverTimestamp(),
      });

      batch.set(
        doc(db, "users", item.userId),
        {
          premium: true,
          premiumActivatedAt: serverTimestamp(),
          lastPaymentUtr: item.utr,
        },
        { merge: true }
      );

      await batch.commit();

      alert("✅ Payment Approved\n💎 Premium Activated");

      await loadRequests();
    } catch (err) {
      console.error(err);
      alert("❌ Approval Failed");
    }
  };

  const rejectPayment = async (item) => {
    if (
      !window.confirm(
        `यह payment reject करें?\n\nUTR: ${item.utr}`
      )
    ) {
      return;
    }

    try {
      const batch = writeBatch(db);

      batch.update(doc(db, "paymentRequests", item.id), {
        status: "rejected",
        reviewedAt: serverTimestamp(),
      });

      await batch.commit();

      alert("❌ Payment Rejected");

      await loadRequests();
    } catch (err) {
      console.error(err);
      alert("❌ Reject Failed");
    }
  };

  return (
    <div
      style={{
        marginTop: "25px",
        padding: "15px",
        border: "2px solid #ddd",
        borderRadius: "10px",
        background: "#fafafa",
      }}
    >
      <h2>💰 Payment Requests</h2>

      <button
        onClick={loadRequests}
        style={{ marginBottom: "15px" }}
      >
        🔄 Refresh Requests
      </button>

      {loading && <p>Loading...</p>}

      {!loading && requests.length === 0 && (
        <p>कोई payment request नहीं है।</p>
      )}

      {requests.map((item) => (
        <div
          key={item.id}
          style={{
            padding: "15px",
            marginBottom: "15px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            background: "white",
          }}
        >
          <b>👤 {item.userName || "User"}</b>

          <p>📧 {item.userEmail}</p>

          <p>
            💰 Amount: <b>₹{item.amount}</b>
          </p>

          <p>
            🔢 UTR: <b>{item.utr}</b>
          </p>

          <p>💳 UPI: {item.upiId}</p>

          <p>
            Status: <b>{item.status}</b>
          </p>

          {item.status === "pending" && (
            <>
              <button
                onClick={() => approvePayment(item)}
                style={{
                  marginRight: "8px",
                  background: "green",
                  color: "white",
                  padding: "10px",
                }}
              >
                ✅ Approve
              </button>

              <button
                onClick={() => rejectPayment(item)}
                style={{
                  background: "red",
                  color: "white",
                  padding: "10px",
                }}
              >
                ❌ Reject
              </button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default PaymentRequests;
